module.exports = __webpack_public_path__ + "static/img/earth.3bb72c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/earth.png
// module id = sqhW
// module chunks = 1